import Box from "@/common/components/Box";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import ResumeBox from "@/common/components/ResumeBox";
import { formatCurrency, formatDateTime } from "@/common/utils/formatters";
import { CompanyData, EstablishmentCompanyData } from "@/features/company/types/company.type";
import { negotiationProductValueLabelByAction } from "@/features/negotiations/constants/negotiationStatus.constant";
import { NegotiationProductHistoryData } from "@/features/negotiations/types/negotiations.type";
import { BriefcaseBusinessIcon, Building2Icon, CalendarDaysIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface NegotiatingProductHistoryItemProps {
  negotiationproductHistory: NegotiationProductHistoryData;
  company?: CompanyData;
  establishment?: EstablishmentCompanyData;
}

const NegotiatingProductHistoryItem = ({ negotiationproductHistory, company, establishment }: NegotiatingProductHistoryItemProps) => {
  return (
    <div key={negotiationproductHistory.id} className="flex flex-col gap-3">
      <div className="flex justify-between">
        <div className="flex flex-col gap-1">
          {negotiationproductHistory.author_type === 'Client::User' ? (
            <ImageWithDisplayName
              placeholderIcon={BriefcaseBusinessIcon}
              imageUrl={company?.general_information?.company_logo?.url}
              displayName={company?.general_information?.fantasy_name}
            />
          ) : (
            <ImageWithDisplayName
              placeholderIcon={Building2Icon}
              imageUrl={establishment?.general_information?.company_logo?.url}
              displayName={establishment?.general_information?.fantasy_name}
            />
          )}


          <p className="italic text-sm font-light text-white-300">
            por {negotiationproductHistory.author.full_name}
          </p>
        </div>

        <div className="flex items-center gap-1">
          <CalendarDaysIcon strokeWidth={1.5} size={18} />

          <p className="font-light">{formatDateTime(new Date(negotiationproductHistory.created_at))}</p>
        </div>
      </div>

      <Box className={twMerge(
        'p-4 rounded-lg flex flex-col gap-4 bg-white-200',
        negotiationproductHistory.action === 'accept' && 'bg-success-op',
        negotiationproductHistory.action === 'reject' && 'bg-danger-op',
      )}>
        <ResumeBox
          label={negotiationProductValueLabelByAction[(negotiationproductHistory.action || 'counter') as keyof typeof negotiationProductValueLabelByAction]}
          value={formatCurrency(Number(negotiationproductHistory.value))}
        />

        {negotiationproductHistory.observation && (
          <ResumeBox
            label="Justificativa"
            value={negotiationproductHistory.observation}
          />
        )}
      </Box>
    </div>
  );
};

export default NegotiatingProductHistoryItem;
